"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformProjectModule = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformProject_1 = require("./TransformProject");
const TransformMultiInstanceSchematic_1 = require("./TransformMultiInstanceSchematic");
class TransformProjectModule extends TransformObject_1.TransformObject {
    constructor(parent, props) {
        super(parent, {
            name: props.name,
            component: props.component,
            modules: new Set(),
            model: props.model,
            metadata: props.metadata,
            value: props.value,
            isDnp: props.isDnp,
            hideInBom: props.hideInBom,
            catalogRef: props.catalogRef,
        }, props.name, new Set());
        this.deduplicationKey = props.name;
    }
    registerInstance(module) {
        this._sharedData.modules.add(module);
    }
    linkTo(primary) {
        for (const mod of this._sharedData.modules) {
            primary._sharedData.modules.add(mod);
        }
        super.linkTo(primary);
    }
    get dependencies() {
        return [this._sharedData.component, ...this._sharedData.modules];
    }
    compile() {
        const componentRef = this._sharedData.component.compiled.name;
        let metadata;
        for (const mod of this._sharedData.modules) {
            if (mod.compiled.metadata) {
                metadata ??= {};
                Object.assign(metadata, mod.compiled.metadata);
            }
        }
        if (this._sharedData.metadata) {
            metadata ??= {};
            Object.assign(metadata, this._sharedData.metadata);
        }
        const instances = Array.from(this._sharedData.modules).map((mod) => ({
            ref: mod.compiled.ref,
            designId: this.resolveDesignId(mod),
        }));
        return {
            name: this._sharedData.name,
            componentRef,
            instances,
            value: this._sharedData.value ?? metadata?.['Value']?.toString(),
            model: this._sharedData.model,
            metadata,
            isDnp: this._sharedData.isDnp,
            hideInBom: this._sharedData.hideInBom,
            catalogRef: this._sharedData.catalogRef,
        };
    }
    resolveDesignId(mod) {
        let current = mod.parent;
        while (current !== undefined) {
            if (current instanceof TransformMultiInstanceSchematic_1.TransformMultiInstanceSchematic) {
                return current.designId;
            }
            if (current instanceof TransformProject_1.TransformProject) {
                break;
            }
            current = current.parent;
        }
        return mod.parent.designId;
    }
}
exports.TransformProjectModule = TransformProjectModule;
//# sourceMappingURL=TransformProjectModule.js.map